import React from 'react'
import './footer.css'

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className='mainfooter'>
      <div className='footer-links'>
        <a href='https://github.com/gopalgoyal2002' target='_blank' rel='noreferrer'>GitHub</a>
        <a href='https://www.linkedin.com/in/gopal-goyal-863981175/' target='_blank' rel='noreferrer'>LinkedIn</a>
        <a href='https://leetcode.com/gopalgoyal612002/' target='_blank' rel='noreferrer'>LeetCode</a>
        <a href='mailto:gopalgoyal612002@gmail.com'>Email</a>
      </div>
      <p>© {year} Gopal Goyal · Built with React</p>
    </footer>
  )
}
